/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TakeoverHistoryEntryResponse
 */
export interface TakeoverHistoryEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof TakeoverHistoryEntryResponse
     */
    appointmentId: string;
    /**
     * 
     * @type {Date}
     * @memberof TakeoverHistoryEntryResponse
     */
    takeoverTimestampUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof TakeoverHistoryEntryResponse
     */
    appointmentStartTimeUtc: Date;
    /**
     * 
     * @type {Date}
     * @memberof TakeoverHistoryEntryResponse
     */
    appointmentEndTimeUtc: Date;
    /**
     * 
     * @type {boolean}
     * @memberof TakeoverHistoryEntryResponse
     */
    isAllDay: boolean;
    /**
     * 
     * @type {string}
     * @memberof TakeoverHistoryEntryResponse
     */
    purposeKey: string;
    /**
     * 
     * @type {string}
     * @memberof TakeoverHistoryEntryResponse
     */
    location: string | null;
    /**
     * 
     * @type {string}
     * @memberof TakeoverHistoryEntryResponse
     */
    details: string | null;
    /**
     * 
     * @type {string}
     * @memberof TakeoverHistoryEntryResponse
     */
    clientFirstName: string | null;
    /**
     * 
     * @type {string}
     * @memberof TakeoverHistoryEntryResponse
     */
    clientLastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof TakeoverHistoryEntryResponse
     */
    givenUpByUserCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof TakeoverHistoryEntryResponse
     */
    takenOverByUserCode: string | null;
}

/**
 * Check if a given object implements the TakeoverHistoryEntryResponse interface.
 */
export function instanceOfTakeoverHistoryEntryResponse(value: object): value is TakeoverHistoryEntryResponse {
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('takeoverTimestampUtc' in value) || value['takeoverTimestampUtc'] === undefined) return false;
    if (!('appointmentStartTimeUtc' in value) || value['appointmentStartTimeUtc'] === undefined) return false;
    if (!('appointmentEndTimeUtc' in value) || value['appointmentEndTimeUtc'] === undefined) return false;
    if (!('isAllDay' in value) || value['isAllDay'] === undefined) return false;
    if (!('purposeKey' in value) || value['purposeKey'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('clientFirstName' in value) || value['clientFirstName'] === undefined) return false;
    if (!('clientLastName' in value) || value['clientLastName'] === undefined) return false;
    if (!('givenUpByUserCode' in value) || value['givenUpByUserCode'] === undefined) return false;
    if (!('takenOverByUserCode' in value) || value['takenOverByUserCode'] === undefined) return false;
    return true;
}

export function TakeoverHistoryEntryResponseFromJSON(json: any): TakeoverHistoryEntryResponse {
    return TakeoverHistoryEntryResponseFromJSONTyped(json, false);
}

export function TakeoverHistoryEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TakeoverHistoryEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentId': json['appointmentId'],
        'takeoverTimestampUtc': (new Date(json['takeoverTimestampUtc'])),
        'appointmentStartTimeUtc': (new Date(json['appointmentStartTimeUtc'])),
        'appointmentEndTimeUtc': (new Date(json['appointmentEndTimeUtc'])),
        'isAllDay': json['isAllDay'],
        'purposeKey': json['purposeKey'],
        'location': json['location'],
        'details': json['details'],
        'clientFirstName': json['clientFirstName'],
        'clientLastName': json['clientLastName'],
        'givenUpByUserCode': json['givenUpByUserCode'],
        'takenOverByUserCode': json['takenOverByUserCode'],
    };
}

export function TakeoverHistoryEntryResponseToJSON(json: any): TakeoverHistoryEntryResponse {
    return TakeoverHistoryEntryResponseToJSONTyped(json, false);
}

export function TakeoverHistoryEntryResponseToJSONTyped(value?: TakeoverHistoryEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentId': value['appointmentId'],
        'takeoverTimestampUtc': value['takeoverTimestampUtc'].toISOString(),
        'appointmentStartTimeUtc': value['appointmentStartTimeUtc'].toISOString(),
        'appointmentEndTimeUtc': value['appointmentEndTimeUtc'].toISOString(),
        'isAllDay': value['isAllDay'],
        'purposeKey': value['purposeKey'],
        'location': value['location'],
        'details': value['details'],
        'clientFirstName': value['clientFirstName'],
        'clientLastName': value['clientLastName'],
        'givenUpByUserCode': value['givenUpByUserCode'],
        'takenOverByUserCode': value['takenOverByUserCode'],
    };
}

